// client/src/utils/files.ts
const MAX_FILE_BYTES = 10 * 1024 * 1024; // 10MB

export function filterAllowedAndSize(files: File[]) {
  const allowed = ["image/png","image/jpeg","application/pdf",
                   "application/msword",
                   "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
  const ok: File[] = [];
  const errors: string[] = [];
  for (const f of files) {
    if (!allowed.includes(f.type)) {
      errors.push(`${f.name}: סוג קובץ לא נתמך`);
      continue;
    }
    if (f.size > MAX_FILE_BYTES) {
      errors.push(`${f.name}: קובץ גדול מדי (מקסימום 10MB)`);
      continue;
    }
    ok.push(f);
  }
  return { ok, errors };
}
